import React from 'react';
import { graphql, Link, StaticQuery } from 'gatsby';

import TaxonomyBarTab from './taxonomy-bar-tab';
import TaxonomyPanel from './taxonomy-panel';

import { preparedCollectionTaxonomyLabels } from '../../helpers/data-helpers';

export default class TaxonomyMediaPanel extends React.Component {
  constructor(props) {
    super(props);

    this.taxonomyGroups = [
      {
        medium: 'All',
        subGroups: [
          'Epoch',
          'Theme',
        ],
      },
      {
        medium: 'Images',
        subGroups: [
          'Epoch',
          'Style',
          'Theme',
        ],
      },
      {
        medium: 'Books',
        subGroups: [
          'Epoch',
          'Genre',
          'Theme',
          'Type',
        ],
      },
      {
        medium: 'Film',
        subGroups: [
          'Epoch',
          'Genre',
          'Theme',
          'Type',
        ],
      },
      {
        medium: 'Audio',
        subGroups: [
          'Epoch',
          'Genre',
          'Theme',
        ],
      },
    ];

    this.state = {
      // filterTab: (props.filterContext) ? props.filterContext : null,
      filterTab: null,
    };

    this.handleTabClick = this.handleTabClick.bind(this);
  }

  handleTabClick(label) {
    this.setState({ filterTab: label });
  }

  render() {
    let filteredTaxonomy = this.taxonomyGroups.filter(group => group.medium === this.props.mediaGroup);

    if (!filteredTaxonomy || !filteredTaxonomy[0]) {
      return null;
    }

    const filterGroups = filteredTaxonomy[0].subGroups;

    return (
      <StaticQuery
        query={graphql`
        {
          collections:allAirtable(filter:{table:{eq:"Collections"}, data:{Published: {eq: true}}}) {
            edges {
              node {
                data {
                  Medium
                  Epoch
                  Genre
                  Style
                  Theme
                  Type
                }
              }
            }
          }
        }
        `}
        render={data => {
          const filterLabels = {
            'All': {
              'Epoch': preparedCollectionTaxonomyLabels(data.collections, 'All', 'Epoch'),
              'Theme': preparedCollectionTaxonomyLabels(data.collections, 'All', 'Theme'),
            },
            'Images': {
              'Epoch': preparedCollectionTaxonomyLabels(data.collections, 'Images', 'Epoch'),
              'Style': preparedCollectionTaxonomyLabels(data.collections, 'Images', 'Style'),
              'Theme': preparedCollectionTaxonomyLabels(data.collections, 'Images', 'Theme'),
            },
            'Books': {
              'Epoch': preparedCollectionTaxonomyLabels(data.collections, 'Books', 'Epoch'),
              'Genre': preparedCollectionTaxonomyLabels(data.collections, 'Books', 'Genre'),
              'Theme': preparedCollectionTaxonomyLabels(data.collections, 'Books', 'Theme'),
              'Type': preparedCollectionTaxonomyLabels(data.collections, 'Books', 'Type'),
            },
            'Film': {
              'Epoch': preparedCollectionTaxonomyLabels(data.collections, 'Film', 'Epoch'),
              'Genre': preparedCollectionTaxonomyLabels(data.collections, 'Film', 'Genre'),
              'Theme': preparedCollectionTaxonomyLabels(data.collections, 'Film', 'Theme'),
              'Type': preparedCollectionTaxonomyLabels(data.collections, 'Film', 'Type'),
            },
            'Audio': {
              'Epoch': preparedCollectionTaxonomyLabels(data.collections, 'Audio', 'Epoch'),
              'Genre': preparedCollectionTaxonomyLabels(data.collections, 'Audio', 'Genre'),
              'Theme': preparedCollectionTaxonomyLabels(data.collections, 'Audio', 'Theme'),
            },
          };

          return (
            <div className="collections-taxonomy-bar__media-panel">
              <div className="collections-taxonomy-bar__tabs">
                <div className="collections-taxonomy-bar__tab-label">
                  {(this.props.mediaGroup === 'All') ? (
                    <>Filter <span className="hide-small-viewports">All Collections by </span></>
                  ) : (
                    <>Filter <span className="hide-small-viewports">{this.props.mediaGroup} by </span></>
                  )}
                </div>
                <div className="collections-taxonomy-bar__tab-group">
                  {(this.props.filterContext === 'All' || this.props.filterContext === null) ? (
                    <TaxonomyBarTab
                      label={ 'All' }
                      handleTabClick={ this.handleTabClick }
                      selected={(this.props.filterContext === null && this.state.filterTab === null) || this.state.filterTab === 'All' }
                    />
                  ) : (
                    <Link
                      to={`/collections/${this.props.mediaGroup.toLowerCase()}`}
                      className={`collections-taxonomy-bar__tab ${(this.props.filterContext === null || this.state.filterTab === 'All') ? 'selected' : ''}`}
                      onClick={() => this.setState({ filterTab: 'All' })}
                    >
                      All
                    </Link>
                  )}
                  {filterGroups.map((group, idx) => (
                    <TaxonomyBarTab
                      label={ group }
                      handleTabClick={ this.handleTabClick }
                      selected={ this.state.filterTab === group }
                      key={`taxonomy-tab-${idx}`}
                    />
                  ))}
                </div>
              </div>
              <TaxonomyPanel
                mediaGroup={ this.props.mediaGroup }
                taxon={ this.state.filterTab }
                labels={ filterLabels[ this.props.mediaGroup ][ this.state.filterTab ] }
              />
            </div>
          )
        }}
      />
    );
  }
}